export const validKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
export const regexRule = /^\d*$/;
export const regexDecimalRule = /^(\d+(\.\d+)?)?$/;
